module.exports = __webpack_public_path__ + "static/media/viatris.60183448.png";